import { AdminService } from "services/AdminService";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";

export const GeneratePDF = biilData => {
  AdminService.generateDriverBillPDF(biilData).then(res => {
    if (res) {
      try {
        const pdfBlob = new Blob([res], { type: "application/pdf" });
        const pdfURL = URL.createObjectURL(pdfBlob);
        window.open(pdfURL, "_blank");
      } catch {
        toast.error("Something went wrong while downloading. Please try again later.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      }
    } else {
      toast.error("Connection error. Please try again later.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
    }
  });
};
export const GenerateReportPDF = biilData => {
  AdminService.generateDriverReportPDF(biilData).then(res => {
    if (res) {
      try {
        const pdfBlob = new Blob([res], { type: "application/pdf" });
        const pdfURL = URL.createObjectURL(pdfBlob);
        window.open(pdfURL, "_blank");
      } catch {
        toast.error("Something went wrong while downloading. Please try again later.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      }
    } else {
      toast.error("Connection error. Please try again later.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
    }
  });
};

export const GenerateOldBillingsPDF = driverId => {
  AdminService.generateOldDriverBillsPDF(driverId).then(res => {
    if (res) {
      try {
        const pdfBlob = new Blob([res], { type: "application/pdf" });
        const pdfURL = URL.createObjectURL(pdfBlob);
        window.open(pdfURL, "_blank");
      } catch {
        toast.error("Something went wrong while downloading. Please try again later.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      }
    } else {
      toast.error("Connection error. Please try again later.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
    }
  });
};

export const GenerateDriverRoutesPDF = routeData => {
  AdminService.generateDriverRoutesPDF(routeData).then(res => {
    if (res) {
      try {
        const pdfBlob = new Blob([res], { type: "application/pdf" });
        const pdfURL = URL.createObjectURL(pdfBlob);
        window.open(pdfURL, "_blank");
      } catch {
        toast.error("Something went wrong while downloading. Please try again later.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "foo-bar",
          style: { marginBottom: "4rem" },
        });
      }
    } else {
      toast.error("Connection error. Please try again later.", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
    }
  });
};